import posthog from "posthog-js";

/* PostHog analytics for a kids' app:
   - session recordings ON, but all typed text is masked so the
     child's name is never captured
   - no autocapture; we only send hand-picked learning events */

const KEY  = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";
const IS_PROD = process.env.NODE_ENV === "production";

let enabled = false;

export function initAnalytics() {
  if (!KEY || enabled) return;
  posthog.init(KEY, {
    api_host: HOST,
    autocapture: false,
    capture_pageview: false,
    disable_session_recording: !IS_PROD,
    session_recording: {
      maskAllInputs: true,
    },
    persistence: "localStorage",
  });
  enabled = true;
  posthog.capture("app_loaded");
}

export function track(event, props) {
  if (!enabled) return;
  posthog.capture(event, props);
}
